module.exports = __webpack_public_path__ + "static/media/play.1cc909e8.svg";